import { Box, useTheme } from "@mui/material";
import CommonIconButton from "@/modules/common/components/ui-kit/buttons/icon-button";
import { ArrowLeft } from "lucide-react";
import CustomerProfileSkeleton from "./customer-profile-skeleton";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import { useNavigate } from "react-router-dom";
import { PathConstants } from "@/routes/constants";
import { StepperSkeleton } from "@/modules/common/components/ui-kit/stepper";

const CustomerSidebarHeaderSkeleton = ({
  showStepper = true,
}: {
  showStepper?: boolean;
} = {}) => {
  const theme = useTheme();
  const { isMobile } = useScreenSize();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: "100%",
        padding: theme.nawy.spacing.md,
        display: "flex",
        flexDirection: "column",
        border: `1px solid ${theme.nawy.colors.semantic.border.secondary}`,
        borderTopLeftRadius: theme.nawy.radius.md,
        borderLeft: "none",
        gap: theme.nawy.spacing.md,
        borderTop: { mobile: "none" },
      }}
    >
      {!isMobile && (
        <CommonIconButton
          variant="outlined-secondary"
          size="md"
          onClick={() => navigate(PathConstants.HOME)}
        >
          <ArrowLeft
            size={16}
            style={{
              color: theme.nawy.colors.primitives.grey[900],
            }}
          />
        </CommonIconButton>
      )}

      <CustomerProfileSkeleton />
      {showStepper && <StepperSkeleton />}
    </Box>
  );
};

export default CustomerSidebarHeaderSkeleton;
